import { Component, OnInit } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { DeviceCondition_Interface, Empty_DeviceCondition_Interface } from 'src/app/Interface/DeviceCondition_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { DeviceConditionService } from 'src/app/Service/Device/DeviceCondition.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-DeviceConditionList',
  templateUrl: './DeviceConditionList.component.html',
  styleUrls: ['./DeviceConditionList.component.scss']
})
export class DeviceConditionListComponent implements OnInit {

  Token:String=""
  Filter_title:string=""
  page:number=0;
  Procssing:boolean=false

  modalRef_Delete: any;

  constructor(
    private DeviceCondition_Service:DeviceConditionService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private modalService: BsModalService
  ) { }


  DataList_DeviceCondition:Array<DeviceCondition_Interface>=[]
  Data_Seleted_Delete:DeviceCondition_Interface=Empty_DeviceCondition_Interface()

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');
    this.Nav_Service.CheckValidPage(this.Token,2183).subscribe(
      data=>{
        this.ReadData_DeviceCondition()
      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )


  }

  ReadData_DeviceCondition(){
    this.Procssing=true
    this.DeviceCondition_Service.GetRecord(this.Token).subscribe(
      data=>{
        this.DataList_DeviceCondition=data
        this.Procssing=false
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  Change_Filter_title(){
    this.page=0
  }


}
